import React from 'react';
import ApiSauce, { CancelToken, ApiResponse } from 'apisauce';
import ApiConfig from '../../services/config/ApiConfig';
import { IStandardSummaryRequest } from './common';
const ndot_logo = require('../../assets/ndor_logo.png');
import "./summary.module.css"

export interface StandardSummaryTroopAreaReportData {
  troopAreaSections: TroopAreaSection[];
  reportTotals: TroopAreaDataRow;
}

export interface TroopAreaSection {
  troopAreaTitle: string;
  dataRows: TroopAreaDataRow[];
  troopTotals: TroopAreaDataRow;
}

export interface TroopAreaDataRow {
  areaName: string;
  countyName: string;

  numberOfAccidentsTotal: number;
  numberOfAccidentsFatal: number;
  numberOfAccidentsInjury: number;
  personsInjured: number;
  personsKilled: number;

  ytd_numberOfAccidentsTotal: number;
  ytd_numberOfAccidentsFatal: number;
  ytd_numberOfAccidentsInjury: number;
  ytd_personsInjured: number;
  ytd_personsKilled: number;
}

interface Props {
  apiToken: string;
  ssRequest: IStandardSummaryRequest;
}

interface State {
  hasData: boolean;
  troopAreaReportData: { period: string, month: string, year: number, standardSummaryTroopAreaReportData: StandardSummaryTroopAreaReportData };
}

const api = ApiSauce.create({
  ...ApiConfig,
  cancelToken: CancelToken.source().token,
});

export default class TroopAreaReport extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    console.log({ props });

    this.state = {
      hasData: false,
      troopAreaReportData: null,
    };

    api.setHeader('Authorization', props.apiToken);
  }

  componentDidMount(): void {
    api.post(`StandardSummary/TroopAreaReportData`, { ...this.props.ssRequest })
      .then((result: ApiResponse<any>) => {
        if (result.ok) {
          this.setState({
            troopAreaReportData: result.data,
            hasData: true,
          });
        }
      });
  }

  render() {
    const { troopAreaReportData } = this.state;
    if (!troopAreaReportData) {
      return <p>Loading</p>;
    }
    const { reportTotals } = troopAreaReportData?.standardSummaryTroopAreaReportData;
    const sectionDivider = (
      <tr style={{ verticalAlign: 'top' }}>
        <th style={{ textAlign: 'left' }}></th>
        <th style={{ textAlign: 'left' }}></th>
        <th style={{ textAlign: 'right' }}>---------</th>
        <th style={{ textAlign: 'right' }}>---------</th>
        <th style={{ textAlign: 'right' }}>---------</th>
        <th style={{ textAlign: 'right', borderLeft: '2px solid black' }}>---------</th>
        <th style={{ textAlign: 'right' }}>---------</th>
        <th style={{ textAlign: 'right', borderLeft: '2px solid black' }}>---------</th>
        <th style={{ textAlign: 'right' }}>---------</th>
        <th style={{ textAlign: 'right' }}>---------</th>
        <th style={{ textAlign: 'right', borderLeft: '2px solid black' }}>---------</th>
        <th style={{ textAlign: 'right' }}>---------</th>
      </tr>);

    return (
      <>
        <div className='page-break' style={{ margin: '10px auto' }}>
          <header>
            <div>
              <p>Report date: {Intl.DateTimeFormat('sv-SE').format(new Date())}</p>
            </div>
            <div style={{ textAlign: "center" }}>
              <p>SUMMARY OF NEBRASKA TRAFFIC CRASHES</p>
              <p>BY NEBRASKA STATE PATROL TROOP AREA AND COUNTY</p>
              <p>For {troopAreaReportData?.period} {troopAreaReportData?.year}</p>
            </div>
            <div className="logo">
              <img
                src={ndot_logo}
                alt="Nebraska Department of Roads"
              />
            </div>
          </header>
          <table className="fatalities-table" style={{ width: "100%", marginTop: 10 }}>
            <thead>
              <tr>
                <td colSpan={2}></td>
                <td colSpan={10} style={{ textAlign: 'center' }}>{'<--------------------------------- Current Month and Year to Date Totals --------------------------------->'}</td>
              </tr>
              <tr>
                <td colSpan={2}></td>
                <td colSpan={5} style={{ textAlign: 'center' }}>{'<-------------------- ' + troopAreaReportData.period + ' -------------------->'}</td>
                <td colSpan={5} style={{ textAlign: 'center', borderLeft: '2px solid black' }}>{'<---------------- Year to Date ---------------->'}</td>
              </tr>
              <tr style={{ verticalAlign: 'bottom' }}>
                <th colSpan={2}></th>
                <th colSpan={3} style={{ textAlign: 'center' }}>Number of Crashes</th>
                <th colSpan={2} style={{ textAlign: 'center' }}>Total</th>
                <th colSpan={3} style={{ textAlign: 'center', borderLeft: '2px solid black' }}>Number of Crashes</th>
                <th colSpan={2} style={{ textAlign: 'center' }}>Total</th>
              </tr>
              <tr style={{ verticalAlign: 'bottom' }}>
                <th style={{ textAlign: 'left' }}>Troop<br />Area</th>
                <th style={{ textAlign: 'left' }}>County</th>
                <th style={{ textAlign: 'right' }}>Total</th>
                <th style={{ textAlign: 'right' }}>Fatal</th>
                <th style={{ textAlign: 'right' }}>Injury</th>
                <th style={{ textAlign: 'right', borderLeft: '2px solid black' }}>Injured</th>
                <th style={{ textAlign: 'right' }}>Killed</th>
                <th style={{ textAlign: 'right', borderLeft: '2px solid black' }}>Total</th>
                <th style={{ textAlign: 'right' }}>Fatal</th>
                <th style={{ textAlign: 'right' }}>Injury</th>
                <th style={{ textAlign: 'right', borderLeft: '2px solid black' }}>Injured</th>
                <th style={{ textAlign: 'right' }}>Killed</th>
              </tr>
              <tr style={{ verticalAlign: 'top' }}>
                <th style={{ textAlign: 'left' }}>---------</th>
                <th style={{ textAlign: 'left' }}>---------</th>
                <th style={{ textAlign: 'right' }}>---------</th>
                <th style={{ textAlign: 'right' }}>---------</th>
                <th style={{ textAlign: 'right' }}>---------</th>
                <th style={{ textAlign: 'right', borderLeft: '2px solid black' }}>---------</th>
                <th style={{ textAlign: 'right' }}>---------</th>
                <th style={{ textAlign: 'right', borderLeft: '2px solid black' }}>---------</th>
                <th style={{ textAlign: 'right' }}>---------</th>
                <th style={{ textAlign: 'right' }}>---------</th>
                <th style={{ textAlign: 'right', borderLeft: '2px solid black' }}>---------</th>
                <th style={{ textAlign: 'right' }}>---------</th>
              </tr>
            </thead>
            <tbody>
              {troopAreaReportData?.standardSummaryTroopAreaReportData?.troopAreaSections.map((section) => {
                const sectionDataRows = section.dataRows.map((row, index) =>
                (
                  <tr>
                    <td style={{ textAlign: 'left' }}>{index == 0 ? row.areaName.replace('Troop', '') : ''}</td>
                    <td style={{ textAlign: 'left' }}>{row.countyName}</td>
                    <td style={{ textAlign: 'right' }}>{row.numberOfAccidentsTotal}</td>
                    <td style={{ textAlign: 'right' }}>{row.numberOfAccidentsFatal}</td>
                    <td style={{ textAlign: 'right' }}>{row.numberOfAccidentsInjury}</td>
                    <td style={{ textAlign: 'right', borderLeft: '2px solid black' }}>{row.personsInjured}</td>
                    <td style={{ textAlign: 'right' }}>{row.personsKilled}</td>
                    <td style={{ textAlign: 'right', borderLeft: '2px solid black' }}>{row.ytd_numberOfAccidentsTotal}</td>
                    <td style={{ textAlign: 'right' }}>{row.ytd_numberOfAccidentsFatal}</td>
                    <td style={{ textAlign: 'right' }}>{row.ytd_numberOfAccidentsInjury}</td>
                    <td style={{ textAlign: 'right', borderLeft: '2px solid black' }}>{row.ytd_personsInjured}</td>
                    <td style={{ textAlign: 'right' }}>{row.ytd_personsKilled}</td>
                  </tr>
                ));
                const sectionTotals = (
                  <React.Fragment>
                    {sectionDivider}
                    <tr>
                      <td style={{ textAlign: 'right' }}>{'    ' + section.troopTotals.areaName + ' Totals'}</td>
                      <td style={{ textAlign: 'left' }}>{section.troopTotals.countyName}</td>
                      <td style={{ textAlign: 'right' }}>{section.troopTotals.numberOfAccidentsTotal}</td>
                      <td style={{ textAlign: 'right' }}>{section.troopTotals.numberOfAccidentsFatal}</td>
                      <td style={{ textAlign: 'right' }}>{section.troopTotals.numberOfAccidentsInjury}</td>
                      <td style={{ textAlign: 'right', borderLeft: '2px solid black' }}>{section.troopTotals.personsInjured}</td>
                      <td style={{ textAlign: 'right' }}>{section.troopTotals.personsKilled}</td>
                      <td style={{ textAlign: 'right', borderLeft: '2px solid black' }}>{section.troopTotals.ytd_numberOfAccidentsTotal}</td>
                      <td style={{ textAlign: 'right' }}>{section.troopTotals.ytd_numberOfAccidentsFatal}</td>
                      <td style={{ textAlign: 'right' }}>{section.troopTotals.ytd_numberOfAccidentsInjury}</td>
                      <td style={{ textAlign: 'right', borderLeft: '2px solid black' }}>{section.troopTotals.ytd_personsInjured}</td>
                      <td style={{ textAlign: 'right' }}>{section.troopTotals.ytd_personsKilled}</td>
                    </tr>
                    {sectionDivider}
                  </React.Fragment>
                )
                return (<React.Fragment>
                  {sectionDataRows}
                  {sectionTotals}
                </React.Fragment>
                );
              })}
              {sectionDivider}
              <tr>
                <td style={{ textAlign: 'right' }}>Report Totals</td>
                <td style={{ textAlign: 'right' }}></td>
                <td style={{ textAlign: 'right' }}>{reportTotals?.numberOfAccidentsTotal}</td>
                <td style={{ textAlign: 'right' }}>{reportTotals?.numberOfAccidentsFatal}</td>
                <td style={{ textAlign: 'right' }}>{reportTotals?.numberOfAccidentsInjury}</td>
                <td style={{ textAlign: 'right', borderLeft: '2px solid black' }}>{reportTotals?.personsInjured}</td>
                <td style={{ textAlign: 'right' }}>{reportTotals?.personsKilled}</td>
                <td style={{ textAlign: 'right', borderLeft: '2px solid black' }}>{reportTotals?.ytd_numberOfAccidentsTotal}</td>
                <td style={{ textAlign: 'right' }}>{reportTotals?.ytd_numberOfAccidentsFatal}</td>
                <td style={{ textAlign: 'right' }}>{reportTotals?.ytd_numberOfAccidentsInjury}</td>
                <td style={{ textAlign: 'right', borderLeft: '2px solid black' }}>{reportTotals?.ytd_personsInjured}</td>
                <td style={{ textAlign: 'right' }}>{reportTotals?.ytd_personsKilled}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {this.state.hasData && <div id="allDataReceived"></div>}
      </>
    )
  }
}